<template>
<el-popover placement="top" v-model="visible">
    <p>是否<slot></slot>?</p>
    <div style="text-align: right; margin: 0">
    <el-button size="mini" type="text" @click="visible = false">取消</el-button>
    <el-button type="primary" size="mini" @click="visible = false;onConfirm()">确定</el-button>
    </div>
    <el-button :type="type" :size="size" slot="reference"><slot></slot></el-button>
</el-popover>
</template>

<script>
export default {
    data: function(){
        return {
            visible: false
        }
    },
    props: {
        type: {
            type: String,
            default: 'text'
        },
        size: {
            type: String,
            default: 'small'
        }
    },
    methods: {
        onConfirm:function(){
            this.$emit('confirm');
        }
    }
}
</script>

<style>

</style>